import { IAction } from 'legacy/lut/classes/models/onboarding/IAction'
import OnboardingStoreService from 'legacy/lut/classes/services/OnboardingStoreService'

export class ActionHelper {
  public static sortActions = (items: IAction[]): IAction[] => {
    const resultArr: IAction[] = []
    items.forEach((item) => {
      const processParent = items.find((el) => el.Process === item.Process && !el.ParentUUID)
      resultArr.push({
        ...item,
        ProcessSortOrder: processParent ? processParent.SortOrder : 0,
      })
      return
    })
    return OnboardingStoreService.sortFunction(resultArr)
  }
}
